import React, { useState, useEffect, useRef } from "react";
import * as Tone from "tone";
import SEO from './SEO';
import RandomYouTubePlayer from "./RandomYouTubePlayer";
import SiteWatermark from "./SiteWatermark";
import "./Sounds.css";

// List of styles
const styles = [
  "Contemporary Worship",
  "Traditional Hymnal",
  "Uplifting Gospel",
  "Reflective Praise",
  "Energetic Celebration",
  "Soulful R&B",
  "Ambient Spiritual",
  "Acoustic Ballad",
  "Jazz Worship",
  "Rock Praise",
  "Folk Hymn",
  "Classical Hymn",
  "We Wish You a Merry Christmas",
];

// Main chords & melody for each style
const styleData = {
  "Contemporary Worship": {
    chords: [
      { notes: ["C4", "E4", "G4"], duration: "2n" },
      { notes: ["G3", "B3", "D4"], duration: "2n" },
      { notes: ["A3", "C4", "E4"], duration: "2n" },
      { notes: ["F3", "A3", "C4"], duration: "2n" },
    ],
    melody: ["E4", "G4", "A4", "G4", "E4", "D4", "C4"],
  },
  "Traditional Hymnal": {
    chords: [
      { notes: ["F4", "A4", "C5"], duration: "2n" },
      { notes: ["C4", "E4", "G4"], duration: "2n" },
      { notes: ["D4", "F4", "A4"], duration: "2n" },
      { notes: ["Bb3", "D4", "F4"], duration: "2n" },
    ],
    melody: ["A4", "C5", "D5", "C5", "A4", "G4", "F4"],
  },
  "Uplifting Gospel": {
    chords: [
      { notes: ["D4", "F#4", "A4"], duration: "2n" },
      { notes: ["A3", "C#4", "E4"], duration: "2n" },
      { notes: ["Bm3", "D4", "F#4"], duration: "2n" },
      { notes: ["G3", "B3", "D4"], duration: "2n" },
    ],
    melody: ["F#4", "A4", "B4", "A4", "F#4", "E4", "D4"],
  },
  "Reflective Praise": {
    chords: [
      { notes: ["Am3", "C4", "E4"], duration: "2n" },
      { notes: ["F3", "A3", "C4"], duration: "2n" },
      { notes: ["G3", "B3", "D4"], duration: "2n" },
      { notes: ["Em3", "G3", "B3"], duration: "2n" },
    ],
    melody: ["C4", "E4", "F4", "E4", "C4", "B3", "A3"],
  },
  "Energetic Celebration": {
    chords: [
      { notes: ["G3", "B3", "D4"], duration: "2n" },
      { notes: ["D3", "F#3", "A3"], duration: "2n" },
      { notes: ["Em3", "G3", "B3"], duration: "2n" },
      { notes: ["C3", "E3", "G3"], duration: "2n" },
    ],
    melody: ["B3", "D4", "E4", "D4", "B3", "A3", "G3"],
  },
  "Soulful R&B": {
    chords: [
      { notes: ["Dm3", "F3", "A3"], duration: "2n" },
      { notes: ["G3", "Bb3", "D4"], duration: "2n" },
      { notes: ["Em3", "G3", "B3"], duration: "2n" },
      { notes: ["Am3", "C4", "E4"], duration: "2n" },
    ],
    melody: ["F3", "A3", "Bb3", "A3", "F3", "E3", "D3"],
  },
  "Ambient Spiritual": {
    chords: [
      { notes: ["C3", "E3", "G3"], duration: "1n" },
      { notes: ["E3", "G3", "B3"], duration: "1n" },
    ],
    melody: ["G3", "B3", "C4", "B3"],
  },
  "Acoustic Ballad": {
    chords: [
      { notes: ["G3", "C4", "E4"], duration: "2n" },
      { notes: ["A3", "D4", "F4"], duration: "2n" },
      { notes: ["B3", "E4", "G4"], duration: "2n" },
      { notes: ["C4", "F4", "A4"], duration: "2n" },
    ],
    melody: ["E4", "G4", "A4", "G4", "E4", "D4", "C4"],
  },
  "Jazz Worship": {
    chords: [
      { notes: ["C4", "Eb4", "G4", "Bb4"], duration: "2n" },
      { notes: ["F3", "A3", "C4", "E4"], duration: "2n" },
      { notes: ["D3", "F3", "A3", "C4"], duration: "2n" },
      { notes: ["G3", "Bb3", "D4", "F4"], duration: "2n" },
    ],
    melody: ["Eb4", "G4", "Bb4", "G4"],
  },
  "Rock Praise": {
    chords: [
      { notes: ["E3", "G#3", "B3"], duration: "2n" },
      { notes: ["A3", "C#4", "E4"], duration: "2n" },
      { notes: ["B3", "D#4", "F#4"], duration: "2n" },
      { notes: ["A3", "C#4", "E4"], duration: "2n" },
    ],
    melody: ["G#3", "B3", "C#4", "B3", "G#3"],
  },
  "Folk Hymn": {
    chords: [
      { notes: ["D3", "F3", "A3"], duration: "2n" },
      { notes: ["G3", "B3", "D4"], duration: "2n" },
      { notes: ["A3", "C4", "E4"], duration: "2n" },
      { notes: ["D3", "F3", "A3"], duration: "2n" },
    ],
    melody: ["F3", "A3", "B3", "A3", "F3"],
  },
  "Classical Hymn": {
    chords: [
      { notes: ["F3", "A3", "C4"], duration: "2n" },
      { notes: ["G3", "B3", "D4"], duration: "2n" },
      { notes: ["Am3", "C4", "E4"], duration: "2n" },
      { notes: ["Bb3", "D4", "F4"], duration: "2n" },
    ],
    melody: ["A3", "C4", "D4", "C4", "A3"],
  },
  "We Wish You a Merry Christmas": {
    chords: [
      { notes: ["C"], duration: "2n" },
      { notes: ["D"], duration: "2n" },
      { notes: ["Bm", "Em", "C", "D", "G"], duration: "2n" },
    ],
    melody: [],
  },
};

// Additional instrument patterns for each style
const styleInstrumentData = {
  "Contemporary Worship": {
    drums: "C2, D2",
    flute: "E5, G5, A5, G5",
    violin: "G4, A4, B4, A4",
    guitar: "C4, E4, G4",
    tabla: "D2, F2, D2, F2",
    sitar: "E3, G3, B3, G3",
  },
  "Traditional Hymnal": {
    drums: "D2, C2",
    flute: "F5, A5, G5, F5",
    violin: "F4, G4, A4, G4",
    guitar: "F4, A4, C5",
    tabla: "C2, Eb2, C2, Eb2",
    sitar: "D3, F3, A3, F3",
  },
  "Uplifting Gospel": {
    drums: "C2, D2",
    flute: "E5, G5, A5, G5",
    violin: "G4, A4, B4, A4",
    guitar: "C4, E4, G4",
    tabla: "D2, F2, D2, F2",
    sitar: "E3, G3, B3, G3",
  },
  "Reflective Praise": {
    drums: "E2, G2",
    flute: "A5, C6, B5, A5",
    violin: "A4, C5, E5, C5",
    guitar: "A3, C4, E4",
    tabla: "D2, F2, D2, F2",
    sitar: "E3, G3, B3, G3",
  },
  "Energetic Celebration": {
    drums: "G2, A2",
    flute: "B5, D6, C6, B5",
    violin: "G4, B4, D5, B4",
    guitar: "G3, B3, D4",
    tabla: "F2, A2, F2, A2",
    sitar: "C3, E3, G3, E3",
  },
  "Soulful R&B": {
    drums: "D2, F2",
    flute: "G5, Bb5, A5, G5",
    violin: "D4, F4, A4, F4",
    guitar: "D3, F3, A3",
    tabla: "C2, Eb2, C2, Eb2",
    sitar: "F3, A3, C4, A3",
  },
  "Ambient Spiritual": {
    drums: "C2, E2",
    flute: "C6, E6, G6, E6",
    violin: "C4, E4, G4, E4",
    guitar: "C4, E4, G4",
    tabla: "G2, Bb2, G2, Bb2",
    sitar: "A3, C4, E4, C4",
  },
  "Acoustic Ballad": {
    drums: "G2, C3",
    flute: "D5, F5, G5, F5",
    violin: "G3, B3, D4, B3",
    guitar: "G3, C4, E4",
    tabla: "E2, G2, E2, G2",
    sitar: "B3, D4, G4, D4",
  },
  "Jazz Worship": {
    drums: "F2, G2",
    flute: "C6, Bb5, A5, G5",
    violin: "C4, E4, G4, E4",
    guitar: "C4, E4, G4",
    tabla: "D2, F2, D2, F2",
    sitar: "E3, G3, B3, G3",
  },
  "Rock Praise": {
    drums: "G2, A2",
    flute: "D6, C6, B5, A5",
    violin: "E4, G#4, B4, G#4",
    guitar: "E4, G#4, B4",
    tabla: "D2, F2, D2, F2",
    sitar: "E3, G3, B3, G3",
  },
  "Folk Hymn": {
    drums: "D2, F2",
    flute: "A5, G5, F5, G5",
    violin: "D4, F4, A4, F4",
    guitar: "D3, F3, A3",
    tabla: "C2, Eb2, C2, Eb2",
    sitar: "D3, F3, A3, F3",
  },
  "Classical Hymn": {
    drums: "F2, G2",
    flute: "C6, D6, E6, D6",
    violin: "F4, A4, C5, A4",
    guitar: "F3, A3, C4",
    tabla: "G2, Bb2, G2, Bb2",
    sitar: "E3, G3, B3, G3",
  },
  "We Wish You a Merry Christmas": {
    drums: "G2, A2",
    flute: "C6, B5, A5, G5",
    violin: "Bm, Em, C, D, G",
    guitar: "C, D, Bm, Em, C, D, G",
    tabla: "D2, F2, D2, F2",
    sitar: "E3, G3, B3, G3",
  },
};

const defaultStyle = styles[0];

const instrumentList = [
  { key: "drums", label: "Drums" },
  { key: "flute", label: "Flute" },
  { key: "violin", label: "Violin" },
  { key: "guitar", label: "Guitar" },
  { key: "tabla", label: "Tabla" },
  { key: "sitar", label: "Sitar" },
];

const getInstrumentPatternForStyle = (style) => {
  const data = styleInstrumentData[style] || {};
  return {
    drums: data.drums || "",
    flute: data.flute || "",
    violin: data.violin || "",
    guitar: data.guitar || "",
    tabla: data.tabla || "",
    sitar: data.sitar || "",
  };
};

// Fallback for missing data
styles.forEach((style) => {
  if (!styleData[style]) {
    styleData[style] = {
      chords: [
        { notes: ["C4", "E4", "G4"], duration: "2n" },
        { notes: ["G3", "B3", "D4"], duration: "2n" },
      ],
      melody: ["E4", "G4", "C5"],
    };
  }
  if (!styleInstrumentData[style]) {
    styleInstrumentData[style] = {
      drums: "C2, D2",
      flute: "E5, G5, A5, G5",
      violin: "G4, A4, B4, A4",
      guitar: "C4, E4, G4",
      tabla: "D2, F2, D2, F2",
      sitar: "E3, G3, B3, G3",
    };
  }
});

// Default instrument oscillator types and enabled settings
const defaultInstrumentOsc = {
  drums: "sine",
  flute: "sine",
  violin: "sawtooth",
  guitar: "square",
  tabla: "triangle",
  sitar: "sine",
};

const defaultInstrumentEnabled = {
  drums: false,
  flute: false,
  violin: false,
  guitar: false,
  tabla: false,
  sitar: false,
};

// White keys for a basic keyboard display
const keys = [
  "C3", "D3", "E3", "F3", "G3", "A3", "B3",
  "C4", "D4", "E4", "F4", "G4", "A4", "B4",
];

const KeyboardDisplay = ({ activeNotes }) => (
  <div className="keyboard-display" role="presentation" aria-hidden="true">
    {keys.map((key) => (
      <div
        key={key}
        className={`keyboard-key ${activeNotes.includes(key) ? "keyboard-key--active" : ""}`}
      >
        {key}
      </div>
    ))}
  </div>
);

const SingleStyleAllInstruments = () => {
  // Music & instrument states
  const [isPlaying, setIsPlaying] = useState(false);
  const [selectedStyle, setSelectedStyle] = useState(defaultStyle);
  const [customChords, setCustomChords] = useState("");
  const [customMelody, setCustomMelody] = useState("");
  const [tempo, setTempo] = useState(100);
  const [volume, setVolume] = useState(0);
  const [attack, setAttack] = useState(0.05);
  const [release, setRelease] = useState(1);
  const [useReverb, setUseReverb] = useState(true);
  const [reverbTime, setReverbTime] = useState(2);
  const [reverbWet, setReverbWet] = useState(0.3);
  const [melodyOsc, setMelodyOsc] = useState("sine");
  const [chordOsc, setChordOsc] = useState("triangle");
  const [instrumentEnabled, setInstrumentEnabled] = useState({ ...defaultInstrumentEnabled });
  const [instrumentPattern, setInstrumentPattern] = useState(() =>
    getInstrumentPatternForStyle(defaultStyle)
  );
  const [instrumentOsc, setInstrumentOsc] = useState({ ...defaultInstrumentOsc });
  const [activeMelodyNote, setActiveMelodyNote] = useState("");
  const [activeChordNotes, setActiveChordNotes] = useState([]);
  
  // New state for background music
  const [backgroundMusic, setBackgroundMusic] = useState("None");

  // Refs for Tone.js synths and events
  const chordEventIdRef = useRef(null);
  const melodyEventIdRef = useRef(null);
  const drumEventIdRef = useRef(null);
  const fluteEventIdRef = useRef(null);
  const violinEventIdRef = useRef(null);
  const guitarEventIdRef = useRef(null);
  const tablaEventIdRef = useRef(null);
  const sitarEventIdRef = useRef(null);
  const melodySynthRef = useRef(null);
  const chordSynthRef = useRef(null);
  const drumSynthRef = useRef(null);
  const fluteSynthRef = useRef(null);
  const violinSynthRef = useRef(null);
  const guitarSynthRef = useRef(null);
  const tablaSynthRef = useRef(null);
  const sitarSynthRef = useRef(null);
  const reverbRef = useRef(null);
  const masterVolRef = useRef(null);

  // Ref for background music audio element
  const bgMusicRef = useRef(null);

  // Music library URLs (borrowed from BibleReader)
  const musicURLs = {
    "Calm": "https://www.bensound.com/bensound-music/bensound-slowmotion.mp3",
    "Uplifting": "https://www.bensound.com/bensound-music/bensound-sunny.mp3",
    "Ambient": "https://www.bensound.com/bensound-music/bensound-relaxing.mp3",
    "Peaceful": "https://www.bensound.com/bensound-music/bensound-tenderness.mp3",
    "Serene": "https://www.bensound.com/bensound-music/bensound-slowmotion.mp3",
    "Chill": "https://www.bensound.com/bensound-music/bensound-slowmotion.mp3",
    "Focus": "https://www.bensound.com/bensound-music/bensound-dubstep.mp3",
    "Relax": "https://www.bensound.com/bensound-music/bensound-relaxing.mp3",
    "Meditative": "https://www.bensound.com/bensound-music/bensound-tenderness.mp3",
    "Dreamy": "https://www.bensound.com/bensound-music/bensound-dreams.mp3",
    "Acoustic": "https://www.bensound.com/bensound-music/bensound-acousticbreeze.mp3",
    "Jazz": "https://www.bensound.com/bensound-music/bensound-thejazzpiano.mp3",
    "Nature": "https://www.bensound.com/bensound-music/bensound-betterdays.mp3",
    "Piano": "https://www.bensound.com/bensound-music/bensound-sweet.mp3",
    "Lo-Fi": "https://www.bensound.com/bensound-music/bensound-slowmotion.mp3",
    "Electronic": "https://www.bensound.com/bensound-music/bensound-dubstep.mp3",
    "Upbeat": "https://www.bensound.com/bensound-music/bensound-ukulele.mp3",
    "Epic": "https://www.bensound.com/bensound-music/bensound-epic.mp3",
    "Cinematic": "https://www.bensound.com/bensound-music/bensound-cinematic.mp3",
    "Smooth": "https://www.bensound.com/bensound-music/bensound-smoothjazz.mp3",
    "Soft": "https://www.bensound.com/bensound-music/bensound-slowmotion.mp3"
  };

  const backgroundMusicOptions = [
    "None",
    "Calm",
    "Uplifting",
    "Ambient",
    "Peaceful",
    "Serene",
    "Chill",
    "Focus",
    "Relax",
    "Meditative",
    "Dreamy",
    "Acoustic",
    "Jazz",
    "Nature",
    "Piano",
    "Lo-Fi",
    "Electronic",
    "Upbeat",
    "Epic",
    "Cinematic",
    "Smooth",
    "Soft",
  ];

  // Load style data when selected style changes
  useEffect(() => {
    const mainData = styleData[selectedStyle];
    if (mainData) {
      setCustomChords(mainData.chords.map((ch) => ch.notes.join(", ")).join("; "));
      setCustomMelody(mainData.melody.join(", "));
    }
    setInstrumentPattern(getInstrumentPatternForStyle(selectedStyle));
  }, [selectedStyle]);

  useEffect(() => {
    if (isPlaying) scheduleEvents();
  }, [customChords, customMelody, instrumentPattern]);

  useEffect(() => {
    Tone.Transport.bpm.value = tempo;
  }, [tempo]);

  useEffect(() => {
    if (masterVolRef.current) {
      masterVolRef.current.volume.value = volume;
    }
  }, [volume]);

  const getMainData = () => {
    const data = styleData[selectedStyle];
    const chords = customChords.trim() !== ""
      ? customChords.split(";").map(str => ({
          notes: str.split(",").map(n => n.trim()),
          duration: "2n",
        }))
      : data.chords;
    const melody = customMelody.trim() !== ""
      ? customMelody.split(",").map(n => n.trim())
      : data.melody;
    return { chords, melody };
  };

  // Initialize instruments and audio effects
  const initInstruments = () => {
    [
      melodySynthRef,
      chordSynthRef,
      drumSynthRef,
      fluteSynthRef,
      violinSynthRef,
      guitarSynthRef,
      tablaSynthRef,
      sitarSynthRef,
    ].forEach(ref => {
      if (ref.current) {
        ref.current.dispose();
        ref.current = null;
      }
    });
    if (reverbRef.current) {
      reverbRef.current.dispose();
      reverbRef.current = null;
    }
    if (masterVolRef.current) {
      masterVolRef.current.dispose();
      masterVolRef.current = null;
    }

    masterVolRef.current = new Tone.Volume(volume).toDestination();
    if (useReverb) {
      reverbRef.current = new Tone.Reverb({ decay: reverbTime, wet: reverbWet })
        .connect(masterVolRef.current);
    }

    melodySynthRef.current = new Tone.Synth({
      oscillator: { type: melodyOsc },
      envelope: { attack, release },
    });
    chordSynthRef.current = new Tone.PolySynth(Tone.Synth, {
      oscillator: { type: chordOsc },
      envelope: { attack, release },
    });

    if (useReverb && reverbRef.current) {
      melodySynthRef.current.connect(reverbRef.current);
      chordSynthRef.current.connect(reverbRef.current);
    } else {
      melodySynthRef.current.connect(masterVolRef.current);
      chordSynthRef.current.connect(masterVolRef.current);
    }

    if (instrumentEnabled.drums) {
      drumSynthRef.current = new Tone.MembraneSynth({ oscillator: { type: instrumentOsc.drums } });
      (reverbRef.current ? drumSynthRef.current.connect(reverbRef.current) : drumSynthRef.current.connect(masterVolRef.current));
    }
    if (instrumentEnabled.flute) {
      fluteSynthRef.current = new Tone.Synth({ oscillator: { type: instrumentOsc.flute }, envelope: { attack: 0.2, release: 1.5 } });
      (reverbRef.current ? fluteSynthRef.current.connect(reverbRef.current) : fluteSynthRef.current.connect(masterVolRef.current));
    }
    if (instrumentEnabled.violin) {
      violinSynthRef.current = new Tone.Synth({ oscillator: { type: instrumentOsc.violin }, envelope: { attack: 0.1, release: 1 } });
      (reverbRef.current ? violinSynthRef.current.connect(reverbRef.current) : violinSynthRef.current.connect(masterVolRef.current));
    }
    if (instrumentEnabled.guitar) {
      guitarSynthRef.current = new Tone.Synth({ oscillator: { type: instrumentOsc.guitar }, envelope: { attack: 0.01, decay: 0.2, sustain: 0, release: 0.2 } });
      (reverbRef.current ? guitarSynthRef.current.connect(reverbRef.current) : guitarSynthRef.current.connect(masterVolRef.current));
    }
    if (instrumentEnabled.tabla) {
      tablaSynthRef.current = new Tone.Synth({ oscillator: { type: instrumentOsc.tabla }, envelope: { attack: 0.01, decay: 0.3, sustain: 0, release: 0.3 } });
      (reverbRef.current ? tablaSynthRef.current.connect(reverbRef.current) : tablaSynthRef.current.connect(masterVolRef.current));
    }
    if (instrumentEnabled.sitar) {
      sitarSynthRef.current = new Tone.Synth({ oscillator: { type: instrumentOsc.sitar }, envelope: { attack: 0.05, release: 1 } });
      (reverbRef.current ? sitarSynthRef.current.connect(reverbRef.current) : sitarSynthRef.current.connect(masterVolRef.current));
    }
  };

  // Schedule musical events
  const scheduleEvents = () => {
    Tone.Transport.clear(chordEventIdRef.current);
    Tone.Transport.clear(melodyEventIdRef.current);
    Tone.Transport.clear(drumEventIdRef.current);
    Tone.Transport.clear(fluteEventIdRef.current);
    Tone.Transport.clear(violinEventIdRef.current);
    Tone.Transport.clear(guitarEventIdRef.current);
    Tone.Transport.clear(tablaEventIdRef.current);
    Tone.Transport.clear(sitarEventIdRef.current);

    const { chords, melody } = getMainData();
    let chordIndex = 0;
    chordEventIdRef.current = Tone.Transport.scheduleRepeat((time) => {
      const c = chords[chordIndex % chords.length];
      chordSynthRef.current.triggerAttackRelease(c.notes, c.duration, time);
      setActiveChordNotes(c.notes);
      setTimeout(() => setActiveChordNotes([]), 500);
      chordIndex++;
    }, "2n");

    let melodyIndex = 0;
    melodyEventIdRef.current = Tone.Transport.scheduleRepeat((time) => {
      const note = melody[melodyIndex % melody.length];
      melodySynthRef.current.triggerAttackRelease(note, "8n", time);
      setActiveMelodyNote(note);
      setTimeout(() => setActiveMelodyNote(""), 300);
      melodyIndex++;
    }, "4n");

    if (instrumentEnabled.drums && drumSynthRef.current) {
      const arr = instrumentPattern.drums?.split(",").map(n => n.trim()) || [];
      let idx = 0;
      drumEventIdRef.current = Tone.Transport.scheduleRepeat((time) => {
        const note = arr[idx % arr.length];
        drumSynthRef.current.triggerAttackRelease(note, "8n", time);
        idx++;
      }, "4n");
    }
    if (instrumentEnabled.flute && fluteSynthRef.current) {
      const arr = instrumentPattern.flute?.split(",").map(n => n.trim()) || [];
      let idx = 0;
      fluteEventIdRef.current = Tone.Transport.scheduleRepeat((time) => {
        const note = arr[idx % arr.length];
        fluteSynthRef.current.triggerAttackRelease(note, "8n", time);
        idx++;
      }, "8n");
    }
    if (instrumentEnabled.violin && violinSynthRef.current) {
      const arr = instrumentPattern.violin?.split(",").map(n => n.trim()) || [];
      let idx = 0;
      violinEventIdRef.current = Tone.Transport.scheduleRepeat((time) => {
        const note = arr[idx % arr.length];
        violinSynthRef.current.triggerAttackRelease(note, "8n", time);
        idx++;
      }, "4n");
    }
    if (instrumentEnabled.guitar && guitarSynthRef.current) {
      const arr = instrumentPattern.guitar?.split(",").map(n => n.trim()) || [];
      let idx = 0;
      guitarEventIdRef.current = Tone.Transport.scheduleRepeat((time) => {
        const note = arr[idx % arr.length];
        guitarSynthRef.current.triggerAttackRelease(note, "8n", time);
        idx++;
      }, "4n");
    }
    if (instrumentEnabled.tabla && tablaSynthRef.current) {
      const arr = instrumentPattern.tabla?.split(",").map(n => n.trim()) || [];
      let idx = 0;
      tablaEventIdRef.current = Tone.Transport.scheduleRepeat((time) => {
        const note = arr[idx % arr.length];
        tablaSynthRef.current.triggerAttackRelease(note, "8n", time);
        idx++;
      }, "4n");
    }
    if (instrumentEnabled.sitar && sitarSynthRef.current) {
      const arr = instrumentPattern.sitar?.split(",").map(n => n.trim()) || [];
      let idx = 0;
      sitarEventIdRef.current = Tone.Transport.scheduleRepeat((time) => {
        const note = arr[idx % arr.length];
        sitarSynthRef.current.triggerAttackRelease(note, "8n", time);
        idx++;
      }, "4n");
    }
  };

  // Play background music if selected
  const playBackgroundMusic = () => {
    if (backgroundMusic === "None") return;
    const url = musicURLs[backgroundMusic];
    if (url) {
      const audio = new Audio(url);
      audio.loop = true;
      audio.volume = 0.3;
      bgMusicRef.current = audio;
      audio.play().catch(err => console.error("BG music play error:", err));
    }
  };

  // Stop background music if playing
  const stopBackgroundMusic = () => {
    if (bgMusicRef.current) {
      bgMusicRef.current.pause();
      bgMusicRef.current = null;
    }
  };

  // Start music – including background music if chosen
  const startMusic = async () => {
    await Tone.start();
    Tone.Transport.bpm.value = tempo;
    if (!isPlaying) {
      initInstruments();
      scheduleEvents();
      Tone.Transport.start();
      setIsPlaying(true);
      if (backgroundMusic !== "None") playBackgroundMusic();
    } else {
      scheduleEvents();
    }
  };

  // Stop all music and background audio
  const stopMusic = () => {
    if (isPlaying) {
      Tone.Transport.stop();
      Tone.Transport.cancel();
      if (melodySynthRef.current?.triggerRelease)
        melodySynthRef.current.triggerRelease();
      if (chordSynthRef.current?.releaseAll) chordSynthRef.current.releaseAll();
      if (drumSynthRef.current?.triggerRelease)
        drumSynthRef.current.triggerRelease();
      if (fluteSynthRef.current?.triggerRelease)
        fluteSynthRef.current.triggerRelease();
      if (violinSynthRef.current?.triggerRelease)
        violinSynthRef.current.triggerRelease();
      if (guitarSynthRef.current?.triggerRelease)
        guitarSynthRef.current.triggerRelease();
      if (tablaSynthRef.current?.triggerRelease)
        tablaSynthRef.current.triggerRelease();
      if (sitarSynthRef.current?.triggerRelease)
        sitarSynthRef.current.triggerRelease();

      [
        melodySynthRef,
        chordSynthRef,
        drumSynthRef,
        fluteSynthRef,
        violinSynthRef,
        guitarSynthRef,
        tablaSynthRef,
        sitarSynthRef,
      ].forEach(ref => {
        if (ref.current) {
          ref.current.dispose();
          ref.current = null;
        }
      });

      stopBackgroundMusic();

      setIsPlaying(false);
      setActiveMelodyNote("");
      setActiveChordNotes([]);
    }
  };

  return (
    <div className="music-page">
      <SEO
        title="Music | GCC Worship"
        description="Layer worship instrumentation with YouTube-inspired controls and lush backgrounds."
      />
      <SiteWatermark />
      <div className="music-shell">
        <header className="music-header">
          <p className="music-header__eyebrow">YouTube-Inspired Studio</p>
          <h1>Single‑Style for All Instruments</h1>
          <p className="music-header__description">
            Pick a worship style, dial in oscillators and effects, and keep the interface true to the
            YouTube-like panels from the session console.
          </p>
        </header>

        <section className="music-panel music-panel--wide">
          <div className="music-panel__title">Style &amp; Atmosphere</div>
          <p className="music-panel__subtitle">Choose a signature tone and layer in background textures.</p>
          <div className="music-panel__grid music-panel__grid--small">
            <div className="music-form-group">
              <label htmlFor="styleSelect">Style</label>
              <select
                id="styleSelect"
                value={selectedStyle}
                onChange={(e) => setSelectedStyle(e.target.value)}
                className="music-select"
              >
                {styles.map((s) => (
                  <option key={s} value={s}>
                    {s}
                  </option>
                ))}
              </select>
            </div>
            <div className="music-form-group">
              <label htmlFor="backgroundMusicSelect">Background Music</label>
              <select
                id="backgroundMusicSelect"
                value={backgroundMusic}
                onChange={(e) => setBackgroundMusic(e.target.value)}
                className="music-select"
              >
                {backgroundMusicOptions.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="music-textarea-group">
            <div className="music-textarea-wrap">
              <label htmlFor="customChords">Custom Chords</label>
              <textarea
                id="customChords"
                value={customChords}
                onChange={(e) => setCustomChords(e.target.value)}
                className="music-textarea"
                placeholder='e.g. "C4,E4,G4; G3,B3,D4; ..."'
                rows={4}
              />
            </div>
            <div className="music-textarea-wrap">
              <label htmlFor="customMelody">Custom Melody</label>
              <textarea
                id="customMelody"
                value={customMelody}
                onChange={(e) => setCustomMelody(e.target.value)}
                className="music-textarea"
                placeholder='e.g. "E4, G4, A4, G4, E4, D4, C4"'
                rows={4}
              />
            </div>
          </div>
        </section>

        <div className="music-grid">
          <section className="music-panel">
            <div className="music-panel__title">Oscillator Shapes</div>
            <div className="music-panel__grid">
              <div className="music-form-group">
                <label htmlFor="melodyOsc">Melody Oscillator</label>
                <select
                  id="melodyOsc"
                  value={melodyOsc}
                  onChange={(e) => setMelodyOsc(e.target.value)}
                  className="music-select"
                >
                  <option value="sine">Sine</option>
                  <option value="square">Square</option>
                  <option value="triangle">Triangle</option>
                  <option value="sawtooth">Sawtooth</option>
                </select>
              </div>
              <div className="music-form-group">
                <label htmlFor="chordOsc">Chord Oscillator</label>
                <select
                  id="chordOsc"
                  value={chordOsc}
                  onChange={(e) => setChordOsc(e.target.value)}
                  className="music-select"
                >
                  <option value="sine">Sine</option>
                  <option value="square">Square</option>
                  <option value="triangle">Triangle</option>
                  <option value="sawtooth">Sawtooth</option>
                </select>
              </div>
            </div>
          </section>
          <section className="music-panel">
            <div className="music-panel__title">Dynamics</div>
            <div className="music-slider-grid">
              <div className="music-slider-group">
                <label htmlFor="tempoRange">Tempo: {tempo} BPM</label>
                <input
                  id="tempoRange"
                  type="range"
                  min="60"
                  max="180"
                  value={tempo}
                  onChange={(e) => setTempo(parseInt(e.target.value, 10))}
                  className="music-range"
                />
              </div>
              <div className="music-slider-group">
                <label htmlFor="volumeRange">Volume: {volume} dB</label>
                <input
                  id="volumeRange"
                  type="range"
                  min="-60"
                  max="0"
                  value={volume}
                  onChange={(e) => setVolume(parseInt(e.target.value, 10))}
                  className="music-range"
                />
              </div>
              <div className="music-slider-group">
                <label htmlFor="attackRange">Attack: {attack.toFixed(2)}</label>
                <input
                  id="attackRange"
                  type="range"
                  min="0.01"
                  max="1"
                  step="0.01"
                  value={attack}
                  onChange={(e) => setAttack(parseFloat(e.target.value))}
                  className="music-range"
                />
              </div>
              <div className="music-slider-group">
                <label htmlFor="releaseRange">Release: {release.toFixed(2)}</label>
                <input
                  id="releaseRange"
                  type="range"
                  min="0.5"
                  max="3"
                  step="0.1"
                  value={release}
                  onChange={(e) => setRelease(parseFloat(e.target.value))}
                  className="music-range"
                />
              </div>
            </div>
            <div className="music-control-row">
              <label className="music-toggle">
                <input
                  type="checkbox"
                  checked={useReverb}
                  onChange={(e) => setUseReverb(e.target.checked)}
                  className="music-checkbox"
                />
                Use Reverb
              </label>
            </div>
            {useReverb && (
              <div className="music-reverb-grid">
                <div className="music-slider-group">
                  <label htmlFor="reverbTime">Reverb Time: {reverbTime.toFixed(1)} s</label>
                  <input
                    id="reverbTime"
                    type="range"
                    min="0.5"
                    max="5"
                    step="0.1"
                    value={reverbTime}
                    onChange={(e) => setReverbTime(parseFloat(e.target.value))}
                    className="music-range"
                  />
                </div>
                <div className="music-slider-group">
                  <label htmlFor="reverbWet">
                    Reverb Wet: {(reverbWet * 100).toFixed(0)}%
                  </label>
                  <input
                    id="reverbWet"
                    type="range"
                    min="0"
                    max="1"
                    step="0.05"
                    value={reverbWet}
                    onChange={(e) => setReverbWet(parseFloat(e.target.value))}
                    className="music-range"
                  />
                </div>
              </div>
            )}
          </section>
        </div>

        <section className="music-panel">
          <div className="music-panel__title">Additional Instruments</div>
          <p className="music-panel__subtitle">Layer percussion, strings, and ambient colors.</p>
          <div className="music-instrument-list">
            {instrumentList.map(({ key, label }) => (
              <div key={key} className="music-instrument">
                <label className="music-toggle">
                  <input
                    type="checkbox"
                    checked={instrumentEnabled[key]}
                    onChange={(e) =>
                      setInstrumentEnabled({ ...instrumentEnabled, [key]: e.target.checked })
                    }
                    className="music-checkbox"
                  />
                  {label}
                </label>
                {instrumentEnabled[key] && (
                  <div className="music-instrument-settings">
                    <label htmlFor={`${key}-pattern`}>Pattern</label>
                    <input
                      id={`${key}-pattern`}
                      type="text"
                      value={instrumentPattern[key]}
                      onChange={(e) =>
                        setInstrumentPattern({ ...instrumentPattern, [key]: e.target.value })
                      }
                      className="music-input"
                      placeholder="Comma separated notes"
                    />
                    <label htmlFor={`${key}-osc`}>Oscillator</label>
                    <select
                      id={`${key}-osc`}
                      value={instrumentOsc[key]}
                      onChange={(e) =>
                        setInstrumentOsc({ ...instrumentOsc, [key]: e.target.value })
                      }
                      className="music-select music-select--mini"
                    >
                      <option value="sine">Sine</option>
                      <option value="square">Square</option>
                      <option value="triangle">Triangle</option>
                      <option value="sawtooth">Sawtooth</option>
                    </select>
                  </div>
                )}
              </div>
            ))}
          </div>
        </section>

        <section className="music-panel music-panel--actions">
          <button
            onClick={isPlaying ? stopMusic : startMusic}
            className={`music-play-btn ${isPlaying ? "music-play-btn--stop" : ""}`}
          >
            {isPlaying ? "Stop Music" : "Play Music"}
          </button>
        </section>

        <section className="music-panel music-panel--keyboard">
          <div className="music-panel__title">Keyboard Visual</div>
          <KeyboardDisplay activeNotes={[...activeChordNotes, activeMelodyNote].filter(Boolean)} />
        </section>

        <section className="music-panel music-panel--youtube">
          <div className="music-panel__title">Featured Video</div>
          <RandomYouTubePlayer title="Music - Featured Video" deferUntilScroll={150} />
        </section>
      </div>
    </div>
  );
};

export default SingleStyleAllInstruments;
